import { render, staticRenderFns } from "./GCustomCompetency.vue?vue&type=template&id=e8d8bfb2&scoped=true&"
import script from "./GCustomCompetency.vue?vue&type=script&lang=ts&"
export * from "./GCustomCompetency.vue?vue&type=script&lang=ts&"
import style0 from "./GCustomCompetency.vue?vue&type=style&index=0&id=e8d8bfb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d8bfb2",
  null
  
)

export default component.exports